import { render, staticRenderFns } from "./TheHeaderApp.vue?vue&type=template&id=0035e9b8&"
import script from "./TheHeaderApp.vue?vue&type=script&lang=js&"
export * from "./TheHeaderApp.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderApp.vue?vue&type=style&index=0&id=0035e9b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports